import { c as _c } from "react/compiler-runtime";
import { PREFERENCE_QUERY } from "@/gql/preference";
import { useBuyerStoreData } from "@/hooks/global-multiple";
import { useSearchPreferencesStore } from "@/stores/search-preferences-store";
import { useQuery } from "@apollo/client";
import { useEffect } from "react";
export function useUserPreferences() {
  const $ = _c(27);
  const buyerId = useBuyerStoreData(_temp);
  const {
    preferences: storePreferences,
    setPreferences,
    setLoading,
    setError
  } = useSearchPreferencesStore();
  let t0;
  if ($[0] !== buyerId) {
    t0 = {
      params: {
        getBuyerPreferences: {
          groupId: buyerId
        }
      }
    };
    $[0] = buyerId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = !buyerId;
  let t2;
  if ($[2] !== t0 || $[3] !== t1) {
    t2 = {
      variables: t0,
      skip: t1
    };
    $[2] = t0;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    data,
    loading,
    error,
    refetch
  } = useQuery(PREFERENCE_QUERY, t2);
  let t3;
  let t4;
  if ($[5] !== loading || $[6] !== setLoading) {
    t3 = () => {
      setLoading(loading);
    };
    t4 = [loading, setLoading];
    $[5] = loading;
    $[6] = setLoading;
    $[7] = t3;
    $[8] = t4;
  } else {
    t3 = $[7];
    t4 = $[8];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[9] !== error || $[10] !== setError) {
    t5 = () => {
      if (error) {
        setError(error.message);
      }
    };
    t6 = [error, setError];
    $[9] = error;
    $[10] = setError;
    $[11] = t5;
    $[12] = t6;
  } else {
    t5 = $[11];
    t6 = $[12];
  }
  useEffect(t5, t6);
  let t7;
  if ($[13] !== data?.buyer?.getBuyerPreferences || $[14] !== setPreferences) {
    t7 = () => {
      setPreferences(data?.buyer?.getBuyerPreferences || []);
    };
    $[13] = data?.buyer?.getBuyerPreferences;
    $[14] = setPreferences;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const t8 = data?.buyer?.getBuyerPreferences;
  let t9;
  if ($[16] !== setPreferences || $[17] !== t8) {
    t9 = [t8, setPreferences];
    $[16] = setPreferences;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  useEffect(t7, t9);
  let t10;
  if ($[19] !== data?.buyer?.getBuyerPreferences || $[20] !== storePreferences) {
    t10 = storePreferences.length > 0 ? storePreferences : data?.buyer?.getBuyerPreferences || [];
    $[19] = data?.buyer?.getBuyerPreferences;
    $[20] = storePreferences;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  const preferences = t10;
  let t11;
  if ($[22] !== error || $[23] !== loading || $[24] !== preferences || $[25] !== refetch) {
    t11 = {
      preferences,
      loading,
      error,
      refetch
    };
    $[22] = error;
    $[23] = loading;
    $[24] = preferences;
    $[25] = refetch;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  return t11;
}
function _temp(state) {
  return state.buyerId;
}